(function ($) {
    $(document).ready(function() {

        if($('.page-node-type-poster').length > 0) {
            $(window).on('scroll', function() {
                if(window.scrollY >= (window.innerHeight / 2)) {
                    console.log('Fix');
                    var distance = $('#prevnext-next').offset().left;
                    $('#prevnext-previous, #prevnext-next').addClass('fix');
                    $('#prevnext-next').css('left', distance + 'px')
                } else {
                    console.log('Unfix');
                    $('#prevnext-previous, #prevnext-next').removeClass('fix');
                    $('#prevnext-next').css('left', 'unset');
                }
            });
        }

        $('.we-mega-menu-li').on('mouseenter', function() {

            if($('.search-dropdown-list .mn-sub').hasClass('visible-search')) {
                $('.search-dropdown-list .mn-sub').removeClass('visible-search');
            }

        });

        $('.search-dropdown-list').on('mouseenter', function() {
            $('.search-dropdown-list .mn-sub').addClass('visible-search');
        });

        $('.mn-sub').on('mouseleave', function() {
                if($('.search-dropdown-list .mn-sub').hasClass('visible-search')) {
                    $('.search-dropdown-list .mn-sub').removeClass('visible-search');
                }
        });

        var navigate = false;

        if($('.we-mega-menu-li').length > 0) {

            $('.we-mega-menu-li>a').click(function(e){
                if($(e.target).parent().attr('data-icon').includes('fa-search')) {
                    e.preventDefault();
                    $('.search-dropdown-list#move-this').toggleClass('expand');
                    $('#site-header .outer-wrapper>div .navbar-we-mega-menu').toggleClass('expand-bigger');
                }
            });
        }

        $(window).on('scroll', function() {

            console.log($('#site-header')[0].getBoundingClientRect().y);
            console.log($('#site-header')[0].getBoundingClientRect().y < 80);

            if ($('body')[0].getBoundingClientRect().y <= -5) {
                $('#site-header').addClass('scrolling');
            } else {
                $('#site-header').removeClass('scrolling');
            }
        });

        $('#move-this').appendTo('#site-header .outer-wrapper>div .navbar-we-mega-menu .we-mega-menu-ul');

    });
})(jQuery);